import { createFileRoute } from '@tanstack/react-router';
import { Helmet } from 'react-helmet-async';
import { AgencyMembersListPage, isMemberFilter, type MemberFilter } from '@/features/agency';
import { formatDocumentTitle } from '@/lib/document-title';

/**
 * `?filter=invited` deep-links from the Salons overview strip into a
 * pre-filtered list; the segmented filter writes the same param so the
 * selection survives refresh. `all` is the default and is never written.
 */
type AgencyMembersSearchParams = {
  filter?: MemberFilter;
};

export const Route = createFileRoute('/_auth/agency/members/')({
  validateSearch: (search: Record<string, unknown>): AgencyMembersSearchParams => ({
    ...(isMemberFilter(search.filter) && search.filter !== 'all' ? { filter: search.filter } : {}),
  }),
  component: AgencyMembersListRoute,
});

function AgencyMembersListRoute() {
  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Agency Members')}</title>
      </Helmet>
      <AgencyMembersListPage />
    </>
  );
}
